// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"minimalLayout-module--wrapper--1E3-l","image100":"minimalLayout-module--image100--2Huew"};